/**
 * @file: projectMileageAtDate.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { dateFromValue } from '@euler/utils/datetime';
import differenceInDays from 'date-fns/differenceInDays';

/**
 * Estimate what the odometer will read on a future date, by carrying the last
 * known reading forward at the vehicle's average yearly usage (its mileage
 * spread over its age). Undefined when there is nothing to project from — no
 * reading, or an age that can't be decoded from the VIN.
 */
export const projectMileageAtDate = (
  currentMileage: number | null | undefined,
  age: number,
  date: string | Date,
) => {
  if (age <= 0) return undefined;
  if (currentMileage == null || currentMileage <= 0) return undefined;
  const avgMileagePerYear = currentMileage / age;
  const durationInYears =
    differenceInDays(dateFromValue(date), new Date()) / 365.25;
  return Math.round(currentMileage + avgMileagePerYear * durationInYears);
};
